// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pAOUc","location":"Header_location__3jy_-"};